interface User {
  name: string;
  factoryName: string;
  email: string;
  userId: string;
  intercom: string;
  role: string;
  phone: string;
}
type Action = {
  type: string;
  payload: User;
};

const reducer = (
  state = {
    name: '',
    factoryName: '',
    email: '',
    phone: '',
    userId: '',
    intercom: '',
    role: '',
  },
  action: Action
): {
  name: string;
  factoryName: string;
  email: string;
  phone: string;
  userId: string;
  intercom: string;
  role: string;
} => {
  switch (action.type) {
    case 'saveUser':
      return (state = action.payload);

    default:
      return state;
  }
};

export default reducer;
